// extracted by mini-css-extract-plugin
export default {"form":"EventResultsDialog_form__CkdJF"};